class AddToWantlist extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const collectionId = this.dataset.collectionid;
    const customerId = window.customerApi.getShopifyID();
    let is_added = false;
    if (customerId) {
      is_added = await this.isAdded(collectionId, customerId);
    }
    const subscribed_btn = document.querySelector(
      ".wantlist-button.subscribed"
    );

    if (is_added) {
      showElement(subscribed_btn);
      hideElement(this);
    } else {
      hideElement(subscribed_btn);
      showElement(this);
    }

    // click event handler for this element
    this.addEventListener("click", async (event) => {
      if (!customerId) {
        window.location.href = "/account/login";
        return;
      } else {
        await window.customerApi
          .addToWantList(customerId, collectionId)
          .then((response) => response.json())
          .then((result) => {
            if (!result.data) {
              // if that collection is not added in the Saro-admin.
              window.showToast("error", {
                title: "Error",
                message: "This collection cannot be added to Wantlist",
              });
              return;
            }
            window.showToast("success", {
              title: "Success",
              message: "Added to Wantlist",
            });
            showElement(subscribed_btn);
            hideElement(this);
            // alert("Added to Wantlist");
          })
          .catch((error) => console.log("error", error));
        // console.log("wantlist", JSON.parse(wantlist));
      }
    });
  }

  async isAdded(collectionId, customerId) {
    try {
      const response = await window.customerApi.getWantList(customerId);
      const result = await response.json();
      console.log(result);
      const wantlist = result.data.some(
        (wantlist) => { return wantlist.category.shopify_id == collectionId }
      );
      console.log("wantlist", wantlist, result.data);
      return wantlist;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}

customElements.define("add-wantlist", AddToWantlist);

class ShowWantlist extends HTMLElement {
  constructor() {
    super();
    this.customerId = window.customerApi.getShopifyID();
  }

  async connectedCallback() {
    const response = await window.customerApi.getWantList(this.customerId);
    const wantlists = await response.json();

    this.render(wantlists);
  }

  async render(wantlists) {
    if (wantlists.data.length === 0) {
      this.innerHTML = '<h2 class="title text-center">No Collections added to Your Wantlist</h2>';
      return;
    }
  
    const fetchPromises = wantlists.data.map(async (wantlist, i) => {
      const response = await fetch(`/collections/${wantlist.category.handle}?view=allWantlist`);
      const responseText = await response.text();
      const htmlParsed = new DOMParser().parseFromString(responseText, 'text/html');
      return htmlParsed.body.innerHTML;
    });
  
    const htmlArray = await Promise.all(fetchPromises);
    const html = htmlArray.join('');
  
    this.innerHTML = html;
  
    await new Promise((resolve) => {
      requestAnimationFrame(resolve);
    });
  
    const wantlistItems = this.querySelectorAll('.wantlist_items');
  
    wantlistItems.forEach(async (item) => {
      await $(item).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });

    this.initWantlistRemove();
  }

  async initWantlistRemove() {
    const removeBtns = document.querySelectorAll(".remove_btn");
    removeBtns.forEach((btn) => {
      // console.log('removeBtns', btn);
      btn.addEventListener("click", async (event) => {
        const card = event.target.closest(".dashboard_card");

        event.preventDefault();
        const remove_collection_id = event.target.dataset.collectionid;
        console.log("remove_collection_id", remove_collection_id);
        await window.customerApi
          .removeFromWantlist(this.customerId, remove_collection_id)
          .then((response) => {
            if (response.status === 204 || response.status === 200) {
              card.remove();
            }
          })
          .catch((error) => console.log("error", error));
      });
    });
  }
}

customElements.define("show-wantlist", ShowWantlist);

function hideElement(element) {
  if (element) {
    element.classList.add("hidden");
  }
}

function showElement(element) {
  if (element) {
    element.classList.remove("hidden");
  }
}
